<template>
    <router-view></router-view>
</template>

<script>
import layoutComponent from '@/pages/home/layout.vue'
import { getTabList } from '@/pages/home/config'
export default {
    components: {
        layoutComponent
    },
    data() {
        return {
            menuList: [],
            breadcrumbList: [],
            menuIndex: 0,
            tabList: getTabList()
        }
    },
    // beforeRouteUpdate(to, from, next) {
    //     next()
    //     this.getRouteData()
    // },
    mounted() {
        //this.getRouteData()
    },
    methods: {
        // 获取路由信息
        getRouteData() {
            const routePath = this.$route.path
            for (let i = 0; i < this.tabList.length; i++) {
                const tabItem = this.tabList[i]
                for (let j = 0; j < tabItem.children.length; j++) {
                    const menuItem = tabItem.children[j]
                    if (menuItem.router === routePath) {
                        this.menuList = tabItem.children
                        this.menuIndex = j
                        this.breadcrumbList = [
                            {
                                name: tabItem.name,
                                router: tabItem.router
                            },
                            {
                                name: menuItem.name,
                                router: menuItem.router
                            },
                        ]
                        return
                    }
                }
            }
        },

        // 处理选择菜单事件
        handleSelect(menuIndex) {
            this.menuIndex = menuIndex
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/home/overviewData/index.vue